import type { Entity } from '@backstage/catalog-model';
import { createApiRef } from '@backstage/core-plugin-api';
import { pluginConfig } from '../config';

export const ApiRef = createApiRef<Api>({
  id: `plugin.${pluginConfig.pluginId}.service`,
});

export interface Api {
  /**
   * Returns Entities from the Catalog based on the filters provided. Sorted by the last updated time.
   * @param limit numer to retrieve, default to 20.
   * @param kind kind of the entity to retrieve. Default to Component.
   */
  getComponents(limit?: number, kind?: string): Promise<Entity[]>;
}
